function signUpStatusSelector(
    state: sage.state.IRedux
): "loading" | "none" | "error" | "passwords_dont_match" | "email_exists" {
    return state.user.signUpStatus;
}

export default signUpStatusSelector;
